var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3337 10.0003C13.7313 10.0003 10.0003 13.7313 10.0003 18.3337C10.0003 22.936 13.7313 26.667 18.3337 26.667C22.936 26.667 26.667 22.936 26.667 18.3337C26.667 13.7313 22.936 10.0003 18.3337 10.0003ZM6.66699 18.3337C6.66699 11.8903 11.8903 6.66699 18.3337 6.66699C24.777 6.667 30.0003 11.8903 30.0003 18.3337C30.0003 24.777 24.777 30.0003 18.3337 30.0003C11.8903 30.0003 6.66699 24.777 6.66699 18.3337Z",
    fill: "#7F67BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0244 6.66659L27.8459 12.8451C27.195 13.496 26.1398 13.496 25.4889 12.8451C24.838 12.1942 24.838 11.139 25.4889 10.4881L31.6674 4.30957L34.0244 6.66659Z",
    fill: "#7F67BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.667 5.00033C26.667 4.07985 27.4132 3.33366 28.3337 3.33366L33.3337 3.33366C34.2541 3.33366 35.0003 4.07986 35.0003 5.00033L35.0003 10.0003C35.0003 10.9208 34.2541 11.667 33.3337 11.667C32.4132 11.667 31.667 10.9208 31.667 10.0003L31.667 6.66699L28.3337 6.66699C27.4132 6.66699 26.667 5.9208 26.667 5.00033Z",
    fill: "#7F67BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3337 26.667C19.2541 26.667 20.0003 27.4132 20.0003 28.3337L20.0003 36.667C20.0003 37.5875 19.2541 38.3337 18.3337 38.3337C17.4132 38.3337 16.667 37.5875 16.667 36.667L16.667 28.3337C16.667 27.4132 17.4132 26.667 18.3337 26.667Z",
    fill: "#7F67BE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 32.9167C25 33.8371 24.2538 34.5833 23.3333 34.5833L13.3334 34.5833C12.4129 34.5833 11.6667 33.8371 11.6667 32.9167C11.6667 31.9962 12.4129 31.25 13.3334 31.25L23.3333 31.25C24.2538 31.25 25 31.9962 25 32.9167Z",
    fill: "#7F67BE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.808ad7110ba238336e7cb89ea972e86e.svg";
export { ForwardRef as ReactComponent };